$(document).ready(function(){
  let cartDrawer=document.querySelector(".cart_drawer");
  let cartIcon=document.querySelector(".cart-button-2");
  let addToCartButtons=document.querySelectorAll(".add-to-cart-button");
  let progressMeter=document.querySelector(".progress-meter");
  let progresscounter=document.querySelector(".progress-meter .text");
  let cart_add_btn=document.querySelector('.you_may_prd_btn');
  let isProgressComplete=!1;
  
  function animateProgress(targetWidth,duration){
    let startWidth=0;
    let startTime=null;
    let product_items= $('.cart_drawer_free_shipping_bar').attr('cart-items');
    function step(timestamp){
      if(!startTime)
        startTime=timestamp;
       let progress=Math.min((timestamp-startTime)/duration,1);
       let currentWidth=Math.round(startWidth+progress*(targetWidth-startWidth));
       $('.progress-meter').css('width',currentWidth+"%");
       $(".progress-meter .text").text(currentWidth+"%");
       if(product_items==0){
         isProgressComplete=!1;
         currentWidth=0
       }
      if(currentWidth>=100){
        isProgressComplete=!0;localStorage.setItem('setcurrentWidth',100)
      }
      if(progress<1){
        requestAnimationFrame(step)
      }
    }
    requestAnimationFrame(step)
  }
  
  function handleCartDrawerActivation(){
    setTimeout(()=>{
      if(cartDrawer.classList.contains("active_cart_drawer")){
        // animateProgress(100,2000)
      }
    },100)
  }
  
  if(cartIcon){
    $(document).on("click",'.cart-button-2',function(){
      if(cartDrawer.classList.contains("active_cart_drawer")){
        // animateProgress(100,2000)
      }
    })
  }
  
  $(document).on("click",'.add-to-cart-button',function(){
    
    const $button = $(this); // capture reference to `this` before setTimeout
    var value = $button.attr('data-value');

    $button.closest('.add-to-cart-holder').addClass('loading-atc');
    
    setTimeout(function(){
      handleCartDrawerActivation()
    },3000);
    
    setTimeout(function(){
      $button.closest('.add-to-cart-holder').removeClass('loading-atc');
      $button.val(value);
    }, 4000);
    
  });
  
  $(document).on("click",".you_may_prd_btn",function(){
    setTimeout(function(){
      handleCartDrawerActivation()
    },2000)
  });
  
  let observer=new MutationObserver(function(mutations){
    if(isProgressComplete)
    return;
    mutations.forEach(function(mutation){
      if(mutation.target.classList.contains("active_cart_drawer")){
        // animateProgress(100,2000)
      }
    })
  });
  
  observer.observe(cartDrawer,{attributes:!0,attributeFilter:["class"]});
  
  $(document).on("click",'.remove-button-2',function(){
    isProgressComplete=!1
  })
  
})